import { render, staticRenderFns } from "./PxTablaComponent.vue?vue&type=template&id=408d7a80&scoped=true&"
import script from "./PxTablaComponent.vue?vue&type=script&lang=js&"
export * from "./PxTablaComponent.vue?vue&type=script&lang=js&"
import style0 from "./PxTablaComponent.vue?vue&type=style&index=0&id=408d7a80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d7a80",
  null
  
)

export default component.exports